import { BACKGROUND_TYPES, BackgroundContainer } from 'components/Background';
import { Flex, Padding } from 'components/base/layout-components';
import styled from 'styled-components';
import Text, { Inline } from 'components/base/Text';
import NoAccessDude from 'images/characters/character-no-access.svg';
import get from 'lodash/get';

import { StyledBackground } from 'views/root/views/home/views/dashboard/Dashboard.style';
import { LockedTopBar } from './LockedTopBar';
import { LBArrowLeftIcon, LBButton } from '@linearb/buzz';

const StyledImg = styled.img`
  width: 250px;
  padding-left: 7rem;
`;

const NoTeams = ({ adminToPresent }) => {
  const name = get(adminToPresent, 'name', '');
  const email = get(adminToPresent, 'email', '');
  return (
    <>
      <LockedTopBar />
      <StyledBackground>
        <BackgroundContainer
          justify='center'
          type={BACKGROUND_TYPES.EMPTY_DASHBOARD}
          items='center'
        >
          <Flex direction='column' pt='10rem'>
            <Flex justify='center'>
              <StyledImg src={NoAccessDude} alt='' />
            </Flex>
            <Flex direction='column' items='center'>
              <Text pt='2rem' size='x-x-x-large' weight='300'>
                Cannot access LinearB.
              </Text>
              <Text pt='2rem' size='x-x-x-large' weight='300'>
                Contact your administrator to be assigned to a team.
              </Text>
              {name && email && (
                <Text pt='3rem' size='x-large' weight='300'>
                  {name} (
                  <Inline size='x-large' color='dodgerBlue'>
                    {email}
                  </Inline>
                  ) is a LinearB administrator
                </Text>
              )}
              <Padding padding='large'>
                <LBButton
                  onClick={() => {
                    window.location = '/login';
                  }}
                >
                  <LBArrowLeftIcon />
                  Return to Login
                </LBButton>
              </Padding>
            </Flex>
          </Flex>
        </BackgroundContainer>
      </StyledBackground>
    </>
  );
};

export default NoTeams;
